export default {
    queryStringConverter(query) {
        const parser = /([^=?&]+)=?([^&]*)/g;
        const result = {};
        let part;
        /* Little nifty parsing hack, leverage the fact that RegExp.exec increments
        the lastIndex property so we can continue executing this loop until we've
        parsed all results. */
        const decode = input => decodeURIComponent(input.replace(/\+/g, ' '));
        // eslint-disable-next-line no-cond-assign
        for (; part = parser.exec(query); result[decode(part[1])] = decode(part[2]));
        return result;
    },

    getQueryStringParam(value) {
        const key = value ? value.toLowerCase().trim() : value;
        const qsObj = this.queryStringConverter(location.search.substring(1));
        let result = '';
        Object.keys(qsObj).forEach((k) => {
            if (typeof qsObj[k] !== 'function') {
                if (k.toLowerCase() === key) result = qsObj[k];
            }
        });
        return result;
    },
};
